import { VUwebSearchService, Query, IAzureSearchService, IAzureSearchResponse } from "@/shared/services/azure-search-service";
import DictionaryMapper from "../mapping/dictionary-mapper";
import { ISearchResult } from "../models/search-model";

export interface ISearchService {
    readonly azureService: IAzureSearchService

    query: Query

    loadData(query: Query): Promise<any>
}

export default class SearchService implements ISearchService {
    readonly azureService!: VUwebSearchService

    query: Query = new Query()

    constructor(index: string, endpoint?: string) {
        this.azureService = new VUwebSearchService(index, endpoint);
    }

    public setSearchQuery(language: string, studyType?: string, faculty?: string) {
        this.query = new Query()
            .SetCount(true)
            .SetSkip(0)
            .SetTop(1000)
            .SetOrderBy('Title asc')
            .SetFilter("ItemType/any(c: c eq 'Study')")
            .AddFilter("ItemType/all(c: not search.in(c, 'PreMaster, Specialization'))")
            .AddFilter(`Language eq '${language.toUpperCase()}'`)

        if (studyType) {
            this.query.AddFilter(`Scopes/any(c: search.in(c, '${studyType}'))`)
        }

        if (faculty) {
            this.query.AddFilter(`Scopes/any(c: search.in(c, '${faculty}'))`)
        }
    }

    public loadData(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.azureService.search(this.query)
                .then((response: IAzureSearchResponse<ISearchResult>) => {
                    resolve(DictionaryMapper.mapSearchResults(response.value))
                })
                .catch((error: Error) => {
                    reject(error)
                })
        })
    }
}